<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          @loadData="loadData"
          :triggerSave.sync="triggerSave"
          :model.sync="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";
import ApiRepository from "@/core/ApiRepository";

const QUERY_AVAILABLE_RULE_EXCHANGE = gql`
  query QueryAvailableRuleExchange($available_id: uuid!) {
    available_rule_exchange(where: {available_id: {_eq: $available_id}, deleted: {_eq: false}}) {
      id
      type_rule
    }
  }
`;

const QUERY_AVAILABLE_RULE_EXCHANGE_IDS = gql`
  query QueryAvailableRuleExchangeIds($available_id: uuid!) {
    available_rule_exchange(where: {available_id: {_eq: $available_id}}) {
      id
    }
  }
`;

const QUERY_AVAILABLE_WEEK_BY_AVAILABLE = gql`
  query QueryAvailableWeekByAvailable($available_id: uuid!) {
    available_week(where: {available_id: {_eq: $available_id}}) {
      id
      visit_start
      visit_end
      index_week_id
    }
  }
`;

const QUERY_AVAILABLE_RULE_EXCHANGE_PROPERTY = gql`
  query QueryAvailableRuleExchangeProperty($rule_id: uuid!) {
    available_rule_exchange_property(where: {available_rule_exchange_id: {_eq: $rule_id}, deleted: {_eq: false}}) {
      id
      property_id
      available_rule_exchange_id
    }
  }
`;


const MUT_INSERT_AVAILABLE_RULE_EXCHANGE = gql`
  mutation InsertAvailableRuleExchange($objects: [available_rule_exchange_insert_input!]!) {
    insert_available_rule_exchange(objects: $objects) {
      returning {
        id
      }
    }
  }
`;

const MUT_INSERT_AVAILABLE_RULE_EXCHANGE_PROPERTY = gql`
  mutation InsertAvailableRuleExchangeProperty($objects: [available_rule_exchange_property_insert_input!]!) {
    insert_available_rule_exchange_property(objects: $objects) {
      affected_rows
    }
  }
`;


const MUT_DELETE_AVAILABLE_RULE_EXCHANGE = gql`
  mutation DeleteAvailableRuleExchange($available_id: uuid!) {
    delete_available_rule_exchange(where: {available_id: {_eq: $available_id}}) {
      affected_rows
    }
  }
`;

const MUT_DELETE_AVAILABLE_RULE_EXCHANGE_PROPERTY_BY_RULE_IDS = gql`
  mutation DeleteAvailableRuleExchangePropertyByRuleIds($rule_ids: [uuid!]!) {
    delete_available_rule_exchange_property(where: {available_rule_exchange_id: {_in: $rule_ids}}) {
      affected_rows
    }
  }
`;

export default {
  watch: {
  },
  components: {
    formEdit
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Create",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      active_check:true,
      users_clubs_id : '',
      time_zone_local : moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted () {
    this.mode = this.$route.name === 'editAvailable' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_AVAILABLE);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-available' });
    },
    async loadData() {
      await this.getData(this.$route.params.id);
    },
    UpdateActive(key){
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if(key == 'lock'){
        this.active_check = false
      }else{
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': {'_eq': this.$route.params.id}
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success',res);
        if(key == 'lock'){
          var query_t =  `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    async saveData(params) {
      // console.log("params",params)
      let objects = {}
      var list_rule_exchange = params.list_rule_exchange || [];
      if (params.type == 3) {
        objects = {
          status: params.status,
          deposit: params.deposit,
          price: params.price,
          rent_thirdparty_price: params.rent_thirdparty_price,
          rent_service_fee_rate: params.rent_service_fee_rate,
          rent_cleaning_fee: params.rent_cleaning_fee,
          rent_other_fee: params.rent_other_fee,
          note: params.note,
          is_admin_update_price: params.is_admin_update_price,
          uid_accept: params.uid_accept,
          owner_id: params.owner_id,
          active: params.active,
          my_property: params.my_property,
          updated_at: moment.tz(new Date(), this.time_zone_local),
          updated_by: this.$store.getters.user
        }
      } else if (params.type == 2) {
        objects = {
          status: params.status,
          note: params.note,
          contact_name: params.contact_name,
          contact_phone: params.contact_phone,
          uid_accept: params.uid_accept,
          active: params.active,
          owner_id: params.owner_id,
          my_property: params.my_property,
          updated_at: moment(new Date()),
          updated_by: this.$store.getters.user
        }
      }
      var response = params.response;
      // var products = params.products;
      this.triggerSave = false;
      if(this.mode == 'add'){
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        await this.$apollo.mutate({
            mutation: DataServices.insertData('available'),
            variables: {
              objects: objects
            }
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
              var returning = res.data[Object.keys(res.data)].returning[0];
              
              if (response.length > 0) {
                response.map(async m => {
                  if (m.is_new) {
                    let list = {
                      available_id: returning.id,
                      status: m.status,
                      uid: m.user.id,
                      updated_by: m?.updated_by || this.$store.getters.user,
                      created_by: m?.created_by || this.$store.getters.user,
                      updated_at: m?.updated_at || new Date(),
                      created_at: m?.created_at || new Date(),
                      total_days: parseInt(m?.total_days || 0),
                      total_amount: parseFloat(m?.total_amount || 0),
                      cleaning_fee: parseFloat(m?.cleaning_fee || 0),
                      other_fee: parseFloat(m?.other_fee || 0),
                      service_fee: parseFloat(m?.service_fee || 0),
                      net_amount: parseFloat(m?.net_amount || 0)
                    }
                    if (params.type == 3) {
                     if (!this.$commonFuction.isEmpty(m.arrival) && !this.$commonFuction.isEmpty(m.departure)){
                     
                      list.arrival = m.arrival
                      list.departure = m.departure
                     }
                    }
                    await this.$apollo.mutate({
                        mutation: DataServices.insertData('available_reponse'),
                        variables: {
                          objects: list
                        }
                    })
                  }
                })
              }
              if (params.type == 2 && list_rule_exchange.length > 0) {
                return Promise.all(list_rule_exchange.map(async rule => {
                  var insertRule = await this.$apollo.mutate({
                    mutation: MUT_INSERT_AVAILABLE_RULE_EXCHANGE,
                    variables: {
                      objects: [{
                        available_id: returning.id,
                        type_rule: parseInt(rule?.type_rule || 3),
                        active: true,
                        deleted: false,
                        created_by: this.$store.getters.user,
                        updated_by: this.$store.getters.user,
                        created_at: moment(new Date()),
                        updated_at: moment(new Date())
                      }]
                    }
                  });
                  var ruleId = insertRule?.data?.insert_available_rule_exchange?.returning?.[0]?.id || null;
                  if (!ruleId) return;
                  var listWeekChange = rule?.list_week_change || [];
                  await Promise.all(listWeekChange.map(async wk => {
                    let startMs = wk?.visit_start_mi;
                    let endMs = wk?.visit_end_mi;
                    let startDate = moment(parseInt(startMs)).toDate();
                    let endDate = moment(parseInt(endMs)).toDate();
                    await this.$apollo.mutate({
                      mutation: DataServices.insertData('available_week'),
                      variables: {
                        objects: {
                          available_id: returning.id,
                          visit_start: startDate,
                          visit_end: endDate,
                          index_week_id: `${moment(startDate).isoWeek()}${moment(startDate).isoWeekYear()}`
                        }
                      }
                    })
                  }));
                  if (parseInt(rule?.type_rule || 0) === 2 || parseInt(rule?.type_rule || 0) === 1) {
                    await Promise.all((rule?.property_ids || []).map(async propertyId => {
                      await this.$apollo.mutate({
                        mutation: MUT_INSERT_AVAILABLE_RULE_EXCHANGE_PROPERTY,
                        variables: {
                          objects: [{
                            available_rule_exchange_id: ruleId,
                            property_id: propertyId,
                            active: true,
                            deleted: false,
                            created_by: this.$store.getters.user,
                            updated_by: this.$store.getters.user,
                            created_at: moment(new Date()),
                            updated_at: moment(new Date())
                          }]
                        }
                      })
                    }));
                  }
                })).then(() => this.redirectEdit())
              }else {
                this.redirectEdit();
              }
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      }else{
        // var user_id = this.$route.params.id;
        let variables = {
          'data_update': objects,
          'where_key': {
            'id': {'_eq': this.models.id}
          }
        }
        await this.$apollo.mutate({
            mutation: DataServices.updateData('available'),
            variables: variables
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
              var returning = res.data[Object.keys(res.data)].returning[0];
              // objects_item.available_id = returning.id;

              if(params.status == 'ST003' && params.status != params.status_old){
                const headers = {
                    "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
                  };
                  var dataUpd = {
                    available_id: this.models.id
                  }
                  var url = '_api/property/cancel_available_admin';
                  ApiRepository.post(url, dataUpd, {headers}).then(() => {
                    // setTimeout(() => {
                    //   this.$emit('loadData');
                    //   this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Cancel request successfully', life: 3000 })
                    // }, 200);
                  })
              }

              if (response.length > 0) {
                response.map(async m => {
                  if (m.is_new) {
                    let list = {
                      available_id: returning.id,
                      property_id: m?.property?.id,
                      status: m.status,
                      uid: m?.user?.id,
                      owner_id: m?.owner?.id,
                      updated_by: m?.updated_by || this.$store.getters.user,
                      updated_at: m?.updated_at || new Date(),
                      total_days: parseInt(m?.total_days || 0),
                      total_amount: parseFloat(m?.total_amount || 0),
                      cleaning_fee: parseFloat(m?.cleaning_fee || 0),
                      other_fee: parseFloat(m?.other_fee || 0),
                      service_fee: parseFloat(m?.service_fee || 0),
                      net_amount: parseFloat(m?.net_amount || 0)
                    }
                    if (params.type == 3) {
                     if (!this.$commonFuction.isEmpty(m.arrival) && !this.$commonFuction.isEmpty(m.departure)){
                     
                     
                      list.arrival = m.arrival
                     list.departure = m.departure
                     }
                    }
                    console.log("list",list)
                    await this.$apollo.mutate({
                      mutation: DataServices.insertData('available_reponse'),
                      variables: {
                        objects: list
                      }
                    })
                  } else if (m.is_updated && m.id) {
                    let list = {
                      status: m.status,
                      uid: m?.user?.id,
                      owner_id: m?.owner?.id,
                      updated_by: m?.updated_by || this.$store.getters.user,
                      updated_at: m?.updated_at || new Date(),
                      total_days: parseInt(m?.total_days || 0),
                      total_amount: parseFloat(m?.total_amount || 0),
                      cleaning_fee: parseFloat(m?.cleaning_fee || 0),
                      other_fee: parseFloat(m?.other_fee || 0),
                      service_fee: parseFloat(m?.service_fee || 0),
                      net_amount: parseFloat(m?.net_amount || 0)
                    }
                    if (params.type == 3) {
                      if (!this.$commonFuction.isEmpty(m.arrival) && !this.$commonFuction.isEmpty(m.departure)) {
                        list.arrival = m.arrival
                        list.departure = m.departure
                      }
                    }
                    await this.$apollo.mutate({
                      mutation: DataServices.updateData('available_reponse'),
                      variables: {
                        data_update: list,
                        where_key: {
                          id: { '_eq': m.id }
                        }
                      }
                    })
                  }
                })
              }
              if (params.type == 2) {
                await this.$apollo.mutate({
                  mutation: DataServices.deleteData('available_week'),
                  variables: {
                    where_key: { available_id: {'_eq': returning.id} },
                  }
                });
                const { data: oldRulesData } = await this.$apollo.query({
                  query: QUERY_AVAILABLE_RULE_EXCHANGE_IDS,
                  variables: { available_id: returning.id },
                  fetchPolicy: "network-only"
                });
                const oldRuleIds = (oldRulesData?.available_rule_exchange || []).map(x => x.id);
                if (oldRuleIds.length > 0) {
                  await this.$apollo.mutate({
                    mutation: MUT_DELETE_AVAILABLE_RULE_EXCHANGE_PROPERTY_BY_RULE_IDS,
                    variables: { rule_ids: oldRuleIds }
                  });
                }
                await this.$apollo.mutate({
                  mutation: MUT_DELETE_AVAILABLE_RULE_EXCHANGE,
                  variables: { available_id: returning.id }
                });
                return Promise.all((list_rule_exchange || []).map(async rule => {
                  var insertRule = await this.$apollo.mutate({
                    mutation: MUT_INSERT_AVAILABLE_RULE_EXCHANGE,
                    variables: {
                      objects: [{
                        available_id: returning.id,
                        type_rule: parseInt(rule?.type_rule || 3),
                        active: true,
                        deleted: false,
                        created_by: this.$store.getters.user,
                        updated_by: this.$store.getters.user,
                        created_at: moment(new Date()),
                        updated_at: moment(new Date())
                      }]
                    }
                  });
                  var ruleId = insertRule?.data?.insert_available_rule_exchange?.returning?.[0]?.id || null;
                  if (!ruleId) return;
                  await Promise.all((rule?.list_week_change || []).map(async wk => {
                    let startDate = moment(parseInt(wk?.visit_start_mi)).toDate();
                    let endDate = moment(parseInt(wk?.visit_end_mi)).toDate();
                    await this.$apollo.mutate({
                      mutation: DataServices.insertData('available_week'),
                      variables: {
                        objects: {
                          available_id: returning.id,
                          visit_start: startDate,
                          visit_end: endDate,
                          index_week_id: `${moment(startDate).isoWeek()}${moment(startDate).isoWeekYear()}`
                        }
                      }
                    })
                  }));
                  if (parseInt(rule?.type_rule || 0) === 2 || parseInt(rule?.type_rule || 0) === 1) {
                    await Promise.all((rule?.property_ids || []).map(async propertyId => {
                      await this.$apollo.mutate({
                        mutation: MUT_INSERT_AVAILABLE_RULE_EXCHANGE_PROPERTY,
                        variables: {
                          objects: [{
                            available_rule_exchange_id: ruleId,
                            property_id: propertyId,
                            active: true,
                            deleted: false,
                            created_by: this.$store.getters.user,
                            updated_by: this.$store.getters.user,
                            created_at: moment(new Date()),
                            updated_at: moment(new Date())
                          }]
                        }
                      })
                    }));
                  }
                })).then(() => this.redirectEdit())
              }else {
                this.redirectEdit();
              }
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      }
      this.$commonFuction.is_loading(false);
    },
    async getOrderCode() {
      var now = new Date();
      var gqLQueryCount = DataServices.countData("visit_need_to_request");
      var countRes = await this.$apollo.mutate({
        mutation: gqLQueryCount,
        variables: {
          where_key: {
            created_at: {_gte: moment(now, this.time_zone_local).startOf('day').toDate(), _lte: moment(now, this.time_zone_local).endOf('day').toDate()}
          }
        }
      });
      var total = countRes.data['visit_need_to_request_aggregate']['aggregate']['count'] + 1;
      var dateImport = moment(now, this.time_zone_local).format("YYYYMMDD");
      var code = `REQUEST${dateImport}${('0000' + total).substr(String(total).length)}`;
      return code;
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-available'};
      that.$commonFuction.is_loading(false);
      if(that.mode == 'add'){
        that.$router.push(router_back);
      }else{
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('available', {
          "fields" : `rent_thirdparty_price rent_service_fee_rate rent_cleaning_fee rent_other_fee id type status owner_id active my_property note property_id created_by create_user{id fullname} user_accept{id fullname email} property{id code name address  admin_property_list { id property_id uid }} visit{id week_number visit_start visit_end} owner{id fullname email} contact_name contact_phone contact_prefix_phone price deposit week{id visit_start visit_end} response{id status arrival departure cleaning_fee other_fee total_days total_amount service_fee net_amount is_send_email user{id fullname email role} property{id name address  } create_user{id fullname email} created_by owner{id fullname email role} visit{id week_number visit_end visit_start} created_at update_user{id fullname} updated_at}`
        }),
        variables: {
          where_key: {
            id: {'_eq': id},
            deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        try {
          const { data: ruleData } = await this.$apollo.query({
            query: QUERY_AVAILABLE_RULE_EXCHANGE,
            variables: {
              available_id: id
            },
            fetchPolicy: "network-only"
          });
          const rules = ruleData?.available_rule_exchange || [];
          const { data: weekDataAll } = await this.$apollo.query({
            query: QUERY_AVAILABLE_WEEK_BY_AVAILABLE,
            variables: { available_id: id },
            fetchPolicy: "network-only"
          });
          const weeksAll = weekDataAll?.available_week || [];
          for (let i = 0; i < rules.length; i++) {
            const rule = rules[i];
            const { data: propData } = await this.$apollo.query({
              query: QUERY_AVAILABLE_RULE_EXCHANGE_PROPERTY,
              variables: {
                rule_id: rule.id
              },
              fetchPolicy: "network-only"
            });
            rule.list_week_change = weeksAll.map(w => ({
              ...w,
              visit_start_mi: moment(w.visit_start).valueOf(),
              visit_end_mi: moment(w.visit_end).valueOf()
            }));
            rule.property_ids = (propData?.available_rule_exchange_property || []).map(p => p.property_id);
            console.log('[DBG][available][function] rule loaded', {
              available_id: id,
              rule_id: rule.id,
              type_rule: rule.type_rule,
              property_ids: rule.property_ids,
              week_count: rule.list_week_change?.length || 0
            });
          }
          this.$set(this.models, 'list_rule_exchange', rules);
          console.log('[DBG][available][function] set model.list_rule_exchange', this.models.list_rule_exchange);
        } catch (errorRule) {
          this.models.list_rule_exchange = [];
          console.log('load available_rule_exchange failed:', errorRule);
        }
        if (this.models?.response) {
          this.models.response.map(async m => {
            await this.$apollo.query({
              query: DataServices.getList('relationship_file', {
                "fields" : `id obj_file{url}`
              }),
              variables: {
                where_key: {
                  obj_id: {'_eq': m?.owner?.id},
                  type: {'_eq': 'USER_AVATAR'}
                }
              },
              fetchPolicy: "network-only"
            }).then((fileData) => {
              if (m?.owner) {
                this.$set(m.owner, 'avatar',fileData?.data?.relationship_file[0] || {});
              }
            })
            
            await this.$apollo.query({
              query: DataServices.getList('relationship_file', {
                "fields" : `id obj_file{url}`
              }),
              variables: {
                where_key: {
                  obj_id: {'_eq': m?.user?.id},
                  type: {'_eq': 'USER_AVATAR'}
                }
              },
              fetchPolicy: "network-only"
            }).then((fileData1) => {
              if (m?.user) {
                this.$set(m.user, 'avatar', fileData1?.data?.relationship_file[0] || {});
              }
            })
            
            // var fileData2 = await this.$apollo.query({
            //   query: DataServices.getList('relationship_file', {
            //     "fields" : `id obj_file{url}`
            //   }),
            //   variables: {
            //     where_key: {
            //       obj_id: {'_eq': m?.create_user?.id},
            //       type: {'_eq': 'USER_AVATAR'}
            //     }
            //   },
            //   fetchPolicy: "network-only"
            // })
            // m.user.avatar = fileData1?.data?.relationship_file[0];
            // m.create_user.avatar = fileData2?.data?.relationship_file[0];
            this.componentKey++;
          })
        }
      }
      this.componentKey++;
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    /* margin-bottom: 16px; */
    padding-bottom: 10px;
    /* border-bottom: 1px solid #EEEEEE; */
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 150px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 10px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.manager-title-row{
  border-bottom: 1px solid #EEEEEE;
}
.p-toolbar-group-right {
  flex-basis: 30%;
}
.p-button-warning.p-button {
  margin: 0 10px;
}
</style>
